import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "relative flex flex-col h-full w-full overflow-hidden",
  ref: "container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["absolute top-0 left-0 h-5 w-[calc(100%-2px)] bg-gradient-bt rounded-b-lg z-20 opacity-0 pointer-events-none transition-opacity duration-300", {
      'opacity-100': _ctx.showTopShadow
    }])
  }, null, 2), _renderSlot(_ctx.$slots, "default"), _createElementVNode("div", {
    class: _normalizeClass(["absolute bottom-0 left-0 h-5 w-[calc(100%-2px)] bg-gradient-tb rounded-t-lg z-20 opacity-0 pointer-events-none transition-opacity duration-300", {
      'opacity-100': _ctx.showBottomShadow
    }])
  }, null, 2)], 512);
}